import React, { useState } from 'react';
import { 
  Container, Paper, Typography, TextField, Button, Box, Alert, CircularProgress 
} from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import { authService } from '../api/services';

const ForgotPassword = () => {
  const { uid, token } = useParams(); // Si existen, estamos en modo "Confirmar"
  const navigate = useNavigate();
  
  const [email, setEmail] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  const isConfirmMode = !!uid && !!token;

  const handleRequestReset = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ type: '', text: '' });

    try {
      await authService.requestPasswordReset(email);
      setMessage({ 
        type: 'success', 
        text: 'Si el correo existe, recibirás un enlace para restablecer tu contraseña.' 
      });
    } catch (error) {
      setMessage({ type: 'error', text: 'Error al solicitar recuperación.' });
    } finally {
      setLoading(false);
    }
  };

  const handleConfirmReset = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      setMessage({ type: 'error', text: 'Las contraseñas no coinciden.' });
      return;
    }

    setLoading(true);
    setMessage({ type: '', text: '' });

    try {
      await authService.confirmPasswordReset({
        uidb64: uid,
        token: token,
        new_password: newPassword
      });
      setMessage({ type: 'success', text: 'Contraseña restablecida exitosamente. Redirigiendo al login...' });
      setTimeout(() => navigate('/login'), 3000);
    } catch (error) {
      setMessage({ type: 'error', text: 'El enlace es inválido o ha expirado.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ py: 8 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h5" gutterBottom fontWeight="bold" align="center">
          {isConfirmMode ? 'Restablecer Contraseña' : 'Recuperar Contraseña'}
        </Typography>

        {message.text && (
          <Alert severity={message.type} sx={{ mb: 3 }}>
            {message.text}
          </Alert>
        )}

        {isConfirmMode ? (
          <Box component="form" onSubmit={handleConfirmReset}>
            <TextField
              fullWidth
              label="Nueva Contraseña"
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              margin="normal"
              required
              helperText="Mínimo 6 caracteres"
            />
            <TextField
              fullWidth
              label="Confirmar Nueva Contraseña"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              margin="normal"
              required
            />
            <Button 
              type="submit" 
              fullWidth 
              variant="contained" 
              sx={{ mt: 3 }}
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} /> : 'Cambiar Contraseña'}
            </Button>
          </Box>
        ) : (
          <Box component="form" onSubmit={handleRequestReset}>
            <Typography variant="body2" color="text.secondary" paragraph align="center">
              Ingresa tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña.
            </Typography>
            <TextField
              fullWidth
              label="Correo Electrónico"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              margin="normal"
              required
            />
            <Button 
              type="submit" 
              fullWidth 
              variant="contained" 
              sx={{ mt: 3 }}
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} /> : 'Enviar Enlace'}
            </Button>
          </Box>
        )}
      </Paper>
    </Container>
  );
};

export default ForgotPassword;
